import { useEffect } from 'react'
import cookie from 'cookie'
import { baseUrl } from 'utils/parseDomain'

const redirectTo = goUrl => window.location.replace(goUrl)

const checkValidSession = () => {
  const cookies = cookie.parse(document.cookie)
  if (
    (typeof cookies.abc !== `undefined` &&
      cookies.abc !== '' &&
      cookies.abc !== 'SatyaNet') ||
    (typeof cookies.ltabc !== `undefined` &&
      cookies.ltabc !== '' &&
      cookies.ltabc !== 'SatyaNet')
  ) {
    redirectTo(`${baseUrl}/default`)
  }
}

function Redirect(props) {
  useEffect(() => {
    checkValidSession()
  }, [])

  return null
}

export default Redirect
